import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DwUtils } from 'src/app/components/utils/dw-utils';
import { Case } from 'src/app/models/case';
import { ServiceRequest } from 'src/app/models/service.request';
import { ValidationResult } from 'src/app/models/validation-result';
import { ServiceRequestsService } from 'src/app/services/service-requests.service';
import { Settings } from 'src/app/services/settings';
import { RequestSummaryComponent } from "../req-summary/req-summary.component";
import { RequestSummary } from "../../../models/request-summary";
import { ServiceDefService } from "../../../services/servicedef.service";
import { TransactionHistoryService } from "../../../services/transactionhistory.service";
import { CasesService } from "../../../services/cases.service";
import { MemberDto } from 'src/app/models/member-dto';
import { ServiceRequestMemberHistory } from 'src/app/models/service-request-member-history';
import { DuplicateMembersComponent } from '../members/dialogs/duplicate-members/duplicate-members.component';
import {
	ConfirmDialogComponent,
	ConfirmDialogModel
} from "../../../components/shared/confirmation-dialog/confirmation-dialog.component";
import { MatLegacyDialog as MatDialog } from "@angular/material/legacy-dialog";

@Component({
	selector: 'app-case-details',
	templateUrl: './case-details.component.html',
	styleUrls: ['./case-details.component.css']
})
export class CaseDetailsComponent implements OnInit {

	public strErr: string | null = '';
	public address1: any | null = '';
	public address2: any | null = '';
	public city: any | null = '';
	public state: any | null = '';
	public zipCode: any | null = '';
	public county: any | null = '';
	public phoneNumber: any | null = '';
	public emailAddress: any | null = '';
	public caseNumber: any | null = '';
	public firstName: any | null = '';
	public middleName: any | null = '';
	public lastName: any | null = '';
	public preference: any | null = '';
	public advocate: any;
	public regionsDataSource: any;
	public incomeDataSource: any;
	public currentNeed = '';
	public advocateEmail = '';
	public advocatePhone: string = '';
	public caseStatus: string;
	public dateOpened: Date;
	public dateClosed: Date;
	public isEditing = false;

	public _caseId = 0;
	public _serviceRequest: ServiceRequest;
	public caseRecord: Case;
	public caseHistory: Case;
	public requestSummary: RequestSummary;
	public placeHolderURL: string = '/assets/profile-img-generic.png';
	public selectedFile: any;
	public valFilePath: any;
	public base64textStringAvatar: string;
	public loading = false;
	public imageAvatarFlag = false;
	public avatarURL = '';
	public primaryAgencyFlag: boolean;
	public assignStatusDlg: boolean = false;
	public caseStatusList: any;
	public result: boolean = false;
	public selectedMemberRecord: MemberDto;
	public showCaseEdit = false;
	public hasClericalOpen = false;
	public isHistoryMode = false;
	public selfHistoryId = 0;
	public advocateHistoryId = 0;
	public selfHistoryRecord: ServiceRequestMemberHistory = null;
	public advocateHistoryRecord: ServiceRequestMemberHistory = null;
	public readCaseAvatar = false;
	public writeCaseAvatar = false;
	public applyCaseStatus = false;
	public readCurrentNeed = false;
	public writeCurrentNeed = false;
	public fromSource = '';

	@Output() editEvent = new EventEmitter<any>();
	@Output() changeStatusEvent = new EventEmitter<any>();
	@Output() caseDetailsSaved = new EventEmitter<void>();

	@Input() set readOnly(value: boolean) {
		//this.readOnlyFlag = value;

	}
	@Input() set from(value: string) {
		this.fromSource = value;

	}
	constructor(private serviceRequestsService: ServiceRequestsService,
		public dialog: MatDialog,
		public txService: TransactionHistoryService,
		public casesService: CasesService,
		public serviceDefService: ServiceDefService) {
		this.requestSummary = new RequestSummary();
	}

	public setSecurityPrivileges() {
		if (this.fromSource === 'cases') {
			this.showCaseEdit = Settings.getInstance().hasPrivilege('CLIENT_EDIT', "EXECUTE");
			this.hasClericalOpen = Settings.getInstance().hasPrivilege('CLIENT_CASE_CLERICAL_OPEN', "EXECUTE");
			this.readCaseAvatar = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_AVATAR', "READ");
			this.writeCaseAvatar = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_AVATAR', "WRITE");
			this.applyCaseStatus = Settings.getInstance().hasPrivilege('CLIENTS_EDIT_CASE_STATUS', "EXECUTE");

			this.writeCurrentNeed = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_CURRENT_NEED', "WRITE");
			this.readCurrentNeed = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_CURRENT_NEED', "READ");
		} else {
			this.showCaseEdit = Settings.getInstance().hasPrivilege('REQUESTS_CLIENT_EDIT', "EXECUTE");
			this.hasClericalOpen = Settings.getInstance().hasPrivilege('REQUESTS_CASE_CLERICAL_OPEN', "EXECUTE");
			this.readCaseAvatar = Settings.getInstance().hasPrivilege('REQUESTS_CASE_DETAILS_AVATAR', "READ");
			this.writeCaseAvatar = Settings.getInstance().hasPrivilege('REQUESTS_CASE_DETAILS_AVATAR', "WRITE");
			this.applyCaseStatus = Settings.getInstance().hasPrivilege('REQUESTS_EDIT_CASE_STATUS', "EXECUTE");

			this.writeCurrentNeed = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_CASE_CURRENT_NEED', "WRITE");
			this.readCurrentNeed = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_CASE_CURRENT_NEED', "READ");
		}
	}

	public ngOnInit() {
		if (Settings.getInstance().regionsList === undefined) {
			this.loadRegionsList();

		}
		this.loadCaseStatuses();
	}
	public loadRegionsList() {
		this.serviceDefService.getAllRegions().subscribe(
			(result) => {
				Settings.getInstance().regionsList = result;
			},
			(error) => {
				Settings.getInstance().handleError('Error: unable to retrieve region data from the service');
			}
		)
	}
	public loadCaseStatuses(): void {

		this.casesService.getAllCaseStatuses().subscribe(
			(result) => {
				this.caseStatusList = result;
			},
			(error) => {
				Settings.getInstance().handleError(error, 'selecting case statuses');
			});
	}
	public onShowHandler(caseId: number, serviceRequest, advocate: any) {
		this.setSecurityPrivileges();
		if (caseId === undefined || caseId === null || isNaN(caseId as any) || caseId < 1) {
			this._caseId = 0;
			this._serviceRequest = serviceRequest || new ServiceRequest();
			this.advocate = advocate;
			this.caseRecord = new Case();
			this.requestSummary = new RequestSummary();
			return;
		}
		this._caseId = caseId;
		this._serviceRequest = serviceRequest || new ServiceRequest();
		this.advocate = advocate;
		this.primaryAgencyFlag = Settings.getInstance().isPrimaryAgency(this._serviceRequest.agencyId);

		if (this._caseId < 1) {
			this.caseRecord = new Case();
			this.requestSummary = new RequestSummary();
			this.displayDetails();
			return;
		}
		if (this.regionsDataSource === undefined) {
			this.regionsDataSource = Settings.getInstance().getCountyDataSource(true);
		}

		this.serviceRequestsService.getCaseById(this._caseId).subscribe(
			(result1) => {
				this.caseRecord = new Case();
				this.caseHistory = new Case();
				Object.assign(this.caseRecord, result1);
				Object.assign(this.caseHistory, result1);		/** store the history record. **/

				if (this.fromSource === 'requests' &&
					(this._serviceRequest?.clericalOpen === 1 || this._serviceRequest?.recordStatus === 0)) {
					this.isHistoryMode = true;
					this.loadMemberHistoryForCaseTab();
				} else {
					this.isHistoryMode = false;
					this.displayDetails();
				}
			},
			(error1) => {
				Settings.getInstance().handleError('Error: unable to retrieve case details from the server');
			}
		);
	}

	private loadMemberHistoryForCaseTab(): void {
		this.casesService.getMemberHistory(this._serviceRequest.id).subscribe(
			(histRecords: ServiceRequestMemberHistory[]) => {
				this.applyHistoryRecordsToCase(histRecords);
				this.displayDetails();
			},
			() => {
				Settings.getInstance().handleError('Error: unable to retrieve member history from the server');
				this.clearHistoryDisplayState();
				this.displayDetails();
			}
		);
	}

	/** History mode only — no live-case fallback when snapshot data is missing */
	private clearHistoryDisplayState(): void {
		this.selfHistoryId = 0;
		this.selfHistoryRecord = null;
		this.advocateHistoryId = 0;
		this.advocateHistoryRecord = null;
		this.advocate = null;
	}

	private applyHistoryRecordsToCase(histRecords: ServiceRequestMemberHistory[]): void {
		this.clearHistoryDisplayState();

		const self = histRecords.find(h => h.relationship === 'Self');
		if (self) {
			this.selfHistoryId = self.id;
			this.selfHistoryRecord = self;
		}

		const adv = histRecords.find(h => h.relationship === 'Advocate');
		if (adv) {
			this.advocateHistoryId = adv.id;
			this.advocateHistoryRecord = adv;
			if (!ServiceRequestMemberHistory.isContactOnlyAdvocate(adv)) {
				this.advocate = adv;
			}
		}
	}

	public submitRecord() {
		let record = this.caseRecord.clone();
		record.firstName = this.firstName;
		record.middleName = this.middleName;
		record.lastName = this.lastName;
		record.phoneNumber = this.phoneNumber;
		record.email = this.emailAddress;
		record.address1 = this.address1;
		record.address2 = this.address2;
		record.state = this.state;
		record.county = this.county;
		record.zipCode = this.zipCode;

		if (this.advocate !== null) {
			if ((this.advocateEmail.length === 0) && (this.advocatePhone.length === 0)) {
				this.strErr = 'Error: At least one contact method is needed for the Advocate';
				DwUtils.setFocus('advocatePhone');
				return;
			}
		}

		record.city = this.city;
		record.currentNeed = this.currentNeed;
		record.advocateEmail = this.advocateEmail;
		record.advocatePhoneNumber = this.advocatePhone;

		this._serviceRequest.currentNeed = this.currentNeed;
		this.strErr = '';

		if (!this.validateFields(record)) {
			return;
		}

		if (this.isHistoryMode && this.selfHistoryId > 0) {
			/** snapshot pre-edit values for the audit log (reopen mode) **/
			const oldSelf: any = this.selfHistoryRecord ? { ...this.selfHistoryRecord } : {};
			const oldAdv: any = this.advocateHistoryRecord ? { ...this.advocateHistoryRecord } : null;
			// Copy full history record to preserve dateOfBirth, gender, memberId, selected etc.
			const h = Object.assign(new ServiceRequestMemberHistory(), this.selfHistoryRecord);
			h.firstName   = record.firstName;
			h.middleName  = record.middleName;
			h.lastName    = record.lastName;
			h.phoneNumber = record.phoneNumber || '';
			h.email       = record.email || '';
			h.currentNeed = record.currentNeed || '';
			h.county      = record.county || '';
			h.address     = [record.address1, record.city, record.state, record.zipCode].filter(x => x).join(', ');
			h.createdBy   = Settings.getInstance().loggedInUser?.username || 'SYSTEM';
			this.casesService.updateMemberHistoryRecord(h).subscribe(
				(updated) => {
					if (updated) {
						this.selfHistoryRecord = updated;
					}
					const finishSave = () => {
						this.isEditing = false;
						/** Audit: reopen-mode edits do not go through updateCase, so log
						 * field-level changes here (advocate + contact + current need). **/
						this.writeReopenAuditHistory(oldSelf, oldAdv, record, h.address);
						this.editEvent.emit(this.isEditing);
						/** Refresh in-modal view + notify parent so the change is visible
						 * without a manual screen refresh. **/
						this.updateServiceRecordValues();
						this.caseDetailsSaved.emit();
						this.loadMemberHistoryForCaseTab();
					};
					if (this.advocateHistoryId > 0 && this.advocateHistoryRecord) {
						const ha = Object.assign(new ServiceRequestMemberHistory(), this.advocateHistoryRecord);
						ha.email       = this.advocateEmail || '';
						ha.phoneNumber = this.advocatePhone || '';
						ha.createdBy   = Settings.getInstance().loggedInUser?.username || 'SYSTEM';
						this.casesService.updateMemberHistoryRecord(ha).subscribe(
							(updatedAdv) => {
								if (updatedAdv) {
									this.advocateHistoryRecord = updatedAdv;
								}
								finishSave();
							},
							() => {
								this.strErr = 'Error: The server could not update advocate history';
							}
						);
					} else if ((this.advocateEmail || '').length > 0 || (this.advocatePhone || '').length > 0) {
						const ha = new ServiceRequestMemberHistory();
						ha.serviceRequestId = this._serviceRequest.id;
						ha.memberId = 0;
						ha.firstName = '';
						ha.middleName = '';
						ha.lastName = '';
						(ha as any).dateOfBirth = null;
						ha.relationship = 'Advocate';
						ha.email = this.advocateEmail || '';
						ha.phoneNumber = this.advocatePhone || '';
						ha.selected = 1;
						ha.createdBy = Settings.getInstance().loggedInUser?.username || 'SYSTEM';
						this.casesService.addMemberToHistory(ha).subscribe(
							(created) => {
								if (created) {
									this.advocateHistoryId = created.id;
									this.advocateHistoryRecord = created;
									this.advocate = created;
								}
								finishSave();
							},
							() => {
								this.strErr = 'Error: The server could not create advocate history';
							}
						);
					} else {
						finishSave();
					}
				},
				(error) => {
					this.strErr = 'Error: The server could not update member history';
				}
			);
			return;
		}

		this.serviceRequestsService.updateCase(record).subscribe(
			(data) => {
				this.isEditing = false;
				this.serviceRequestsService.updateCaseCurrentNeed(this._serviceRequest, record.id).subscribe(
					(data) => {
						this.isEditing = false;
						this.txService.updateTransactionHistory(this.caseHistory, record, 'Cases', record.id);
						this.editEvent.emit(this.isEditing);
						this.updateServiceRecordValues();
					},
					(error) => {
						this.strErr = 'Error: The server could not update the case record';
						return;
					});
			},
			(error) => {
				this.strErr = 'Error: The server could not update the case record';
				return;
			});
	}
	/** Writes field-level audit rows for a reopen-mode (history) save. The normal
	 * save path audits via updateCase; the history branch does not, so advocate,
	 * current need, address, county, phone and email changes are logged here. These
	 * are keyed to the ServiceRequest (not the Case) because a reopen edit changes
	 * the request's history snapshot - not the live case - which matches how the
	 * reopen action itself is logged and surfaces them in the request Activity tab.
	 * The Audit Log Report still finds them by case number via the SR -> Case join. */
	private writeReopenAuditHistory(oldSelf: any, oldAdv: any, record: Case, newAddress: string): void {
		const before = {
			currentNeed: (oldSelf && oldSelf.currentNeed) || '',
			address: (oldSelf && oldSelf.address) || '',
			county: (oldSelf && oldSelf.county) || '',
			phoneNumber: (oldSelf && oldSelf.phoneNumber) || '',
			email: (oldSelf && oldSelf.email) || '',
			advocateEmail: (oldAdv && oldAdv.email) || '',
			advocatePhoneNumber: (oldAdv && oldAdv.phoneNumber) || ''
		};
		const after = {
			currentNeed: record.currentNeed || '',
			address: newAddress || '',
			county: record.county || '',
			phoneNumber: record.phoneNumber || '',
			email: record.email || '',
			advocateEmail: this.advocateEmail || '',
			advocatePhoneNumber: this.advocatePhone || ''
		};
		this.txService.updateTransactionHistory(before, after, 'ServiceRequests', this._serviceRequest.id);
	}
	public validateFields(record: Case): boolean {

		this.strErr = '';
		const vr: ValidationResult = record.validateRecord();

		if (vr.error.length > 0) {
			this.strErr = vr.error;
			DwUtils.setFocus(vr.focus_field);
			return false;
		}
		return true;
	}
	public updateServiceRecordValues() {
		this._serviceRequest.caseName =
			this.returnFullName('a');
	}
	public cancelSubmitRecord() {
		this.isEditing = false;
		this.strErr = '';
		this.editEvent.emit(this.isEditing);
		this.displayDetails();
	}
	public editRecord() {
		this.isEditing = true;
		DwUtils.highlightFocus('firstName');
		this.editEvent.emit(this.isEditing);
	}
	public doStatus(): void {
		this.assignStatusDlg = true;

	}
	public returnFullName(nameType): string {

		let retVal: string = '';
		switch (nameType) {
			case 'a':
				retVal = DwUtils.returnFullName(this.firstName, this.middleName, this.lastName);
				break;
			case 'd':
				retVal = DwUtils.returnFullName(this.advocate.firstName, this.advocate.middleName, this.advocate.lastName);
		}

		return retVal;


	}
	public doAssignStatusSubmitted(caseRec: any): void {
		this.assignStatusDlg = false;
		this.caseStatus = caseRec.caseStatus;
		this.caseRecord.clericalOpen = caseRec.clericalOpen;
		this.caseRecord.dateOpened = caseRec.dateOpened;
		this.caseRecord.dateClosed = caseRec.dateClosed;
		this.dateOpened = this.caseRecord.dateOpened;
		this.dateClosed = this.caseRecord.dateClosed;
		this.changeStatusEvent.emit(caseRec);
	}
	public displayDetails() {
		this.caseNumber = this._serviceRequest?.caseNumber || this.caseRecord.caseNumber;

		if (this.isHistoryMode) {
			if (this.selfHistoryRecord) {
				this.firstName = this.selfHistoryRecord.firstName || '';
				this.middleName = this.selfHistoryRecord.middleName || '';
				this.lastName = this.selfHistoryRecord.lastName || '';
				this.emailAddress = this.selfHistoryRecord.email || '';
				this.phoneNumber = this.selfHistoryRecord.phoneNumber || '';
				this.county = this.selfHistoryRecord.county || '';
				this.currentNeed = this.selfHistoryRecord.currentNeed || '';
				const addrParts = (this.selfHistoryRecord.address || '').split(', ');
				this.address1 = addrParts[0] || '';
				this.address2 = '';
				this.city = addrParts[1] || '';
				this.state = addrParts[2] || '';
				this.zipCode = addrParts[3] || '';
			} else {
				this.firstName = '';
				this.middleName = '';
				this.lastName = '';
				this.emailAddress = '';
				this.phoneNumber = '';
				this.county = '';
				this.currentNeed = '';
				this.address1 = '';
				this.address2 = '';
				this.city = '';
				this.state = '';
				this.zipCode = '';
			}
		} else {
			this.firstName = this.caseRecord.firstName;
			this.middleName = this.caseRecord.middleName;
			this.lastName = this.caseRecord.lastName;
			this.address1 = this.caseRecord.address1;
			this.address2 = this.caseRecord.address2;
			this.zipCode = this.caseRecord.zipCode;
			this.state = this.caseRecord.state;
			this.city = this.caseRecord.city;
			this.emailAddress = this.caseRecord.email;
			this.phoneNumber = this.caseRecord.phoneNumber;
			this.county = this.caseRecord.county;
			this.currentNeed = this._serviceRequest?.currentNeed || this.caseRecord.currentNeed || '';
		}

		if (!this.caseRecord.caseStatus) {
			this.caseRecord.caseStatus = 'Open';
		}
		if (!this.caseRecord.dateOpened) {
			this.caseRecord.dateOpened = this.caseRecord.dateCreated;
		}
		this.caseStatus = this.caseRecord.caseStatus;
		this.dateOpened = this.caseRecord.dateOpened;
		this.dateClosed = this.caseRecord.dateClosed;

		if (this.isHistoryMode) {
			this.advocateEmail = this.advocateHistoryRecord?.email || '';
			this.advocatePhone = this.advocateHistoryRecord?.phoneNumber || '';
		} else {
			this.advocateEmail = this.caseRecord.advocateEmail;
			this.advocatePhone = this.caseRecord.advocatePhoneNumber;
		}

		this.doLoadAvatarImage();

		if (this._serviceRequest) {
			this.setRequestSummary();
		}
	}
	public setRequestSummary(): void {

		this.requestSummary.dateCreated = Settings.getInstance().formatDate(this._serviceRequest.dateCreated);
		this.requestSummary.requestType = this._serviceRequest.serviceRequestDesc;
		this.requestSummary.statusDesc = this._serviceRequest.requestStatusDesc;
		this.requestSummary.amountRequested = DwUtils.returnBlankForNull(this._serviceRequest.amountRequested);
		this.requestSummary.unitOfMeasure = this._serviceRequest.unitOfMeasure;
		this.requestSummary.currentNeed = (this.isHistoryMode && this.selfHistoryRecord)
			? this.selfHistoryRecord.currentNeed
			: this._serviceRequest.currentNeed;
		if (this._serviceRequest.flatRequestId) {
			this.requestSummary.source = 'Universal Form';
		} else {
			this.requestSummary.source = 'Data Entry';
		}
		this.requestSummary.agencyName = Settings.getInstance().getAgencyName(this._serviceRequest.agencyId);
		this.requestSummary.statusColor = this.getStatusColor(this._serviceRequest.requestStatusId);

	}
	public getStatusColor(requestStatusId: number): string {
		switch (requestStatusId) {
			case 1:
				return 'black'; // Unmatched
			case 2:
				return 'blue'; // Matched
			case 3:
				return 'green'; // Approved
			case 4:
				return 'red'; // Denied
			case 5:
				return 'orange'; // Cancelled
			default:
				return ''; // Handle any other status or return a default color
		}
	}
	public getCaseStatusColor(): string {
		if (!this.caseStatus) { return; }
		switch (this.caseStatus.toLowerCase()) {
			case 'open':
				return 'green';
			case 'closed':
				return 'black';
			default:
				return 'black';
		}
	}
	public fileInputChange(fileInputEvent: any) {
		if (fileInputEvent.target.files[0] === undefined || fileInputEvent.target.files[0] === null) {
			return;
		}

		if (fileInputEvent.target.files[0].size > 409600) {
			Settings.getInstance().handleError('The image file size should not exceed 400KB');
			return;
		}

		this.selectedFile = fileInputEvent.target.files[0];
		this.valFilePath = this.selectedFile.name;
		//this.loading = true;
		const tempImagePath: string = URL.createObjectURL(this.selectedFile);
		this.avatarURL = 'url(' + tempImagePath + ')';
		document.getElementById('avatar').style.backgroundImage = this.avatarURL;
		document.getElementById('avatarCase').style.backgroundImage = this.avatarURL;
		this.serviceRequestsService.updateCaseAvatarImage(this.caseRecord.id, this.selectedFile).subscribe(
			(data) => {
				this.loading = false;
				this.doLoadAvatarImage();

			},
			(error) => {
				Settings.getInstance().handleError(error);
				this.loading = false;
			}
		);

	}
	public doLoadAvatarImage() {
		this.imageAvatarFlag = false;
		this.serviceRequestsService.getCaseAvatarImage(this.caseRecord.id).subscribe(
			(data1) => {
				if (!data1 || data1.size < 5) {
					this.imageAvatarFlag = false;
					this.avatarURL = 'url(' + this.placeHolderURL + ')';
					document.getElementById('avatar').style.backgroundImage = this.avatarURL;
				} else {
					const tempImagePath: string = URL.createObjectURL(data1);
					this.avatarURL = 'url(' + tempImagePath + ')';
					document.getElementById('avatarCase').style.backgroundImage = this.avatarURL;
					this.imageAvatarFlag = true;
				}

			},
			(error1) => {
				this.imageAvatarFlag = false;
				this.avatarURL = 'url(' + this.placeHolderURL + ')';
				document.getElementById('avatar').style.backgroundImage = this.avatarURL;
			}
		);
	}
	public clearAvatar(evt: Event): void {

		if (this.avatarURL.includes(this.placeHolderURL) || this.avatarURL === undefined) {
			return;
		}
		this.avatarURL = 'url(' + this.placeHolderURL + ')';
		this.serviceRequestsService.removeCaseAvatarImage(this.caseRecord.id).subscribe(
			(data) => {
			},
			(error) => {
				Settings.getInstance().handleError(error);
			}
		);
		document.getElementById('avatar').style.backgroundImage = this.avatarURL;
		document.getElementById('avatarCase').style.backgroundImage = this.avatarURL;
		this.avatarURL = '';
	}
	public doReOpenCase(): void {

		// Remove record logic
		const message = 'Re-Open this Case?  - Are you sure?';
		const dialogData = new ConfirmDialogModel('Please Confirm', message);

		const dialogRef = this.dialog.open(ConfirmDialogComponent, {
			width: '400px',
			data: dialogData,
			panelClass: 'custom-dialog-container'
		});

		dialogRef.afterClosed().subscribe(dialogResult => {
			this.result = dialogResult;
			if (this.result === true) {

				this.serviceRequestsService.reOpenClosedCase(this.caseRecord.id).subscribe(
					(result) => {
						this.caseStatus = result.caseStatus;
						this.caseRecord.clericalOpen = result.clericalOpen;
						this.caseRecord.caseStatus = this.caseStatus;

						//this.setRequestSummary();
						/** create a transaction history record **/
						this.txService.createTransactionHistory('Cases', this.caseRecord.id,
							'Re-open', 'Closed record re-opened by administrator');

						this.changeStatusEvent.emit(this.caseRecord);
					},
					(error) => {
						Settings.getInstance().handleError(error, 'Reopening close request')
					});
			}
		});
	}
}
